export const templateParamRegex = /{{[0-9]+}}/g;
